import { render, staticRenderFns } from "./analyticsProductionDashboard.vue?vue&type=template&id=b0c8a674&"
import script from "./analyticsProductionDashboard.vue?vue&type=script&lang=js&"
export * from "./analyticsProductionDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports